"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultComponentStyles = void 0;

var _styles = require("../Button/styles");

var _styles2 = require("../Card/styles");

var _styles3 = require("../SidebarNav/styles");

var _styles4 = require("../Switch/styles");

var _styles5 = require("../Tabs/styles");

var _styles6 = require("../Checkbox/styles");

var _styles7 = require("../Radio/styles");

var _styles8 = require("../Input/styles");

var _styles9 = require("../TextArea/styles");

var _styles10 = require("../Avatar/styles");

var _styles11 = require("../Toolbar/styles");

var _styles12 = require("../Tooltip/styles");

var _styles13 = require("../IconButton/styles");

var _styles14 = require("../Modal/styles");

var _styles15 = require("../ButtonBar/styles");

var _styles16 = require("../Link/styles");

var _styles17 = require("../ToastCard/styles");

var _styles18 = require("../Image/styles");

var defaultComponentStyles = {
  card: _styles2.cardStyles,
  tabs: _styles5.tabsStyles,
  sidebarNav: _styles3.sidebarNavStyles,
  button: _styles.buttonStyles,
  checkbox: _styles6.checkboxStyles,
  switch: _styles4.switchStyles,
  radio: _styles7.radioStyles,
  image: _styles18.imageStyles,
  input: _styles8.inputStyles,
  textarea: _styles9.textareaStyles,
  avatar: _styles10.avatarStyles,
  toolbar: _styles11.toolbarStyles,
  tooltip: _styles12.tooltipStyles,
  iconButton: _styles13.iconButtonStyles,
  modal: _styles14.modalStyles,
  buttonBar: _styles15.buttonBarStyles,
  link: _styles16.linkStyles,
  toastCard: _styles17.toastCardStyles
};
exports.defaultComponentStyles = defaultComponentStyles;